<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-opacity-75 bg-black">
    <div class="relative rounded-lg p-8 bg-gradient-to-br from-gray-300 to-gray-500">
      <slot />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'UiModal',
  }
</script>
